// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'mapa.dispositivosGrid.devices': 'Dispositivos',
    'mapa.dispositivosGrid.countOfTotal': '{{shown}} de {{total}}',
    'mapa.dispositivosGrid.empty': 'Nenhum dispositivo rastreado.',
    // Cabeçalhos de coluna
    'mapa.dispositivosGrid.colTipo': 'Tipo',
    'mapa.dispositivosGrid.colStatusViagem': 'Status viagem',
    'mapa.dispositivosGrid.colOrigem': 'Origem',
    'mapa.dispositivosGrid.colDestino': 'Destino',
    'mapa.dispositivosGrid.colProgramadoPara': 'Programado para',
    'mapa.dispositivosGrid.colPlaca': 'Placa',
    'mapa.dispositivosGrid.colMotorista': 'Motorista',
    'mapa.dispositivosGrid.senhaNoTerminal': 'Senha no terminal: {{nome}}',
    'mapa.dispositivosGrid.colJornada': 'Jornada',
    'mapa.dispositivosGrid.colLocalAtual': 'Local atual',
    'mapa.dispositivosGrid.colCerca': 'Cerca',
    'mapa.dispositivosGrid.colConexao': 'Conexão',
    'mapa.dispositivosGrid.colIgnicao': 'Ignição',
    'mapa.dispositivosGrid.colVelocidade': 'Velocidade',
    'mapa.dispositivosGrid.colSituacao': 'Situação',
    // Tooltips e rótulos acessíveis
    'mapa.dispositivosGrid.locateAria': 'Localizar {{label}} no mapa',
    'mapa.dispositivosGrid.openInGoogleMaps': 'Abrir {{label}} no Google Maps',
    'mapa.dispositivosGrid.noPositionForMaps': 'Sem coordenada transmitida',
    'mapa.dispositivosGrid.transporteBadge': 'Transp. Máquina',
    'mapa.dispositivosGrid.transporteBadgeTooltip': 'Prancha em viagem de Transporte de Máquina: o status exibido é o do veículo nessa viagem, sob o contrato de destino.',
    'mapa.dispositivosGrid.programadoTooltip': 'Data e hora programada da carga na Frente de Trabalho. Na prancha, a data de início da viagem de máquina',
    'mapa.dispositivosGrid.inStatusSince': 'Neste status desde {{date}}',
    'mapa.dispositivosGrid.temperatureReading': 'Leitura de {{date}}',
    'mapa.dispositivosGrid.listBelowMap': 'Lista abaixo do mapa',
    'mapa.dispositivosGrid.listRightSide': 'Lista na lateral direita',
    // Filtros
    'mapa.dispositivosGrid.filterByClient': 'Filtrar por cliente',
    'mapa.dispositivosGrid.client': 'Cliente',
    'mapa.dispositivosGrid.searchClient': 'Buscar cliente…',
    'mapa.dispositivosGrid.searchScheduledDate': 'Buscar data…',
    'mapa.dispositivosGrid.filterByTripStatus': 'Filtrar por status da viagem',
    'mapa.dispositivosGrid.searchStatus': 'Buscar status…',
    'mapa.dispositivosGrid.filterByCategory': 'Filtrar por categoria do veículo',
    'mapa.dispositivosGrid.category': 'Categoria',
    'mapa.dispositivosGrid.category.espiga': 'Espiga',
    'mapa.dispositivosGrid.category.granel': 'Granel',
    'mapa.dispositivosGrid.category.prancha': 'Prancha',
    'mapa.dispositivosGrid.category.maquina': 'Máquina',
    'mapa.dispositivosGrid.category.combustivel': 'Combustível',
    'mapa.dispositivosGrid.searchCategory': 'Buscar categoria…',
    'mapa.dispositivosGrid.filterByPair': 'Filtrar por dupla',
    'mapa.dispositivosGrid.pair': 'Dupla',
    'mapa.dispositivosGrid.searchPair': 'Buscar dupla…',
    'mapa.dispositivosGrid.filterByContract': 'Filtrar por contrato',
    'mapa.dispositivosGrid.contract': 'Contrato',
    'mapa.dispositivosGrid.garage': 'Garagem',
    'mapa.dispositivosGrid.searchContract': 'Buscar contrato…',
    'mapa.dispositivosGrid.searchFence': 'Buscar cerca…',
    'mapa.dispositivosGrid.noContractFound': 'Nenhum contrato encontrado',
    'mapa.dispositivosGrid.searchPlaceholder': 'Buscar placa, motorista, cidade, origem, destino…',
    // Situação do rastreador
    'mapa.dispositivosGrid.signalTransmitting': 'Transmitindo',
    'mapa.dispositivosGrid.signalLate': 'Atrasado',
    'mapa.dispositivosGrid.signalOffline': 'Sem sinal',
    'mapa.dispositivosGrid.signalNever': 'Sem transmissão',
    'mapa.dispositivosGrid.signalLegendTitle': 'Sinal do rastreador',
    'mapa.dispositivosGrid.signalTransmittingDesc': 'posição nos últimos 10 minutos',
    'mapa.dispositivosGrid.signalLateDesc': 'entre 10 minutos e 2 horas sem transmitir',
    'mapa.dispositivosGrid.signalOfflineDesc': 'mais de 2 horas sem transmitir',
    'mapa.dispositivosGrid.signalNeverDesc': 'nunca enviou posição',
    'mapa.dispositivosGrid.signalLegendNote': 'A cor da linha segue o Status viagem, não a Situação.',
    // Tempo relativo
    'mapa.dispositivosGrid.now': 'agora',
    'mapa.dispositivosGrid.ago': 'há {{value}}',
    'mapa.dispositivosGrid.minsAgo': 'há {{count}} min',
    'mapa.dispositivosGrid.hoursAgo': 'há {{count}} h',
    'mapa.dispositivosGrid.daysAgo': 'há {{count}} d',
  },
  en: {
    'mapa.dispositivosGrid.devices': 'Devices',
    'mapa.dispositivosGrid.countOfTotal': '{{shown}} of {{total}}',
    'mapa.dispositivosGrid.empty': 'No tracked devices.',
    // Cabeçalhos de coluna
    'mapa.dispositivosGrid.colTipo': 'Type',
    'mapa.dispositivosGrid.colStatusViagem': 'Trip status',
    'mapa.dispositivosGrid.colOrigem': 'Origin',
    'mapa.dispositivosGrid.colDestino': 'Destination',
    'mapa.dispositivosGrid.colProgramadoPara': 'Scheduled for',
    'mapa.dispositivosGrid.colPlaca': 'License plate',
    'mapa.dispositivosGrid.colMotorista': 'Driver',
    'mapa.dispositivosGrid.senhaNoTerminal': 'Password on the terminal: {{nome}}',
    'mapa.dispositivosGrid.colJornada': 'Journey',
    'mapa.dispositivosGrid.colLocalAtual': 'Current location',
    'mapa.dispositivosGrid.colCerca': 'Geofence',
    'mapa.dispositivosGrid.colConexao': 'Connection',
    'mapa.dispositivosGrid.colIgnicao': 'Ignition',
    'mapa.dispositivosGrid.colVelocidade': 'Speed',
    'mapa.dispositivosGrid.colSituacao': 'Situation',
    // Tooltips e rótulos acessíveis
    'mapa.dispositivosGrid.locateAria': 'Locate {{label}} on the map',
    'mapa.dispositivosGrid.openInGoogleMaps': 'Open {{label}} in Google Maps',
    'mapa.dispositivosGrid.noPositionForMaps': 'No coordinates transmitted',
    'mapa.dispositivosGrid.transporteBadge': 'Machine transport',
    'mapa.dispositivosGrid.transporteBadgeTooltip': 'Flatbed on a Machine Transport trip: the status shown is the vehicle status of that trip, under the destination contract.',
    'mapa.dispositivosGrid.programadoTooltip': 'Scheduled date and time of the load in the Work Front. For flatbeds, the start date of the machine trip',
    'mapa.dispositivosGrid.inStatusSince': 'In this status since {{date}}',
    'mapa.dispositivosGrid.temperatureReading': 'Reading from {{date}}',
    'mapa.dispositivosGrid.listBelowMap': 'List below the map',
    'mapa.dispositivosGrid.listRightSide': 'List on the right side',
    // Filtros
    'mapa.dispositivosGrid.filterByClient': 'Filter by customer',
    'mapa.dispositivosGrid.client': 'Customer',
    'mapa.dispositivosGrid.searchClient': 'Search customer…',
    'mapa.dispositivosGrid.searchScheduledDate': 'Search date…',
    'mapa.dispositivosGrid.filterByTripStatus': 'Filter by trip status',
    'mapa.dispositivosGrid.searchStatus': 'Search status…',
    'mapa.dispositivosGrid.filterByCategory': 'Filter by vehicle category',
    'mapa.dispositivosGrid.category': 'Category',
    'mapa.dispositivosGrid.category.espiga': 'Ear',
    'mapa.dispositivosGrid.category.granel': 'Bulk',
    'mapa.dispositivosGrid.category.prancha': 'Flatbed',
    'mapa.dispositivosGrid.category.maquina': 'Machine',
    'mapa.dispositivosGrid.category.combustivel': 'Fuel',
    'mapa.dispositivosGrid.searchCategory': 'Search category…',
    'mapa.dispositivosGrid.filterByPair': 'Filter by pair',
    'mapa.dispositivosGrid.pair': 'Pair',
    'mapa.dispositivosGrid.searchPair': 'Search pair…',
    'mapa.dispositivosGrid.filterByContract': 'Filter by contract',
    'mapa.dispositivosGrid.contract': 'Contract',
    'mapa.dispositivosGrid.garage': 'Garage',
    'mapa.dispositivosGrid.searchContract': 'Search contract…',
    'mapa.dispositivosGrid.searchFence': 'Search geofence…',
    'mapa.dispositivosGrid.noContractFound': 'No contract found',
    'mapa.dispositivosGrid.searchPlaceholder': 'Search plate, driver, city, origin, destination…',
    // Situação do rastreador
    'mapa.dispositivosGrid.signalTransmitting': 'Transmitting',
    'mapa.dispositivosGrid.signalLate': 'Delayed',
    'mapa.dispositivosGrid.signalOffline': 'No signal',
    'mapa.dispositivosGrid.signalNever': 'No transmission',
    'mapa.dispositivosGrid.signalLegendTitle': 'Tracker signal',
    'mapa.dispositivosGrid.signalTransmittingDesc': 'position in the last 10 minutes',
    'mapa.dispositivosGrid.signalLateDesc': 'between 10 minutes and 2 hours without transmitting',
    'mapa.dispositivosGrid.signalOfflineDesc': 'more than 2 hours without transmitting',
    'mapa.dispositivosGrid.signalNeverDesc': 'never sent a position',
    'mapa.dispositivosGrid.signalLegendNote': 'The row color follows the Trip status, not the Situation.',
    // Tempo relativo
    'mapa.dispositivosGrid.now': 'now',
    'mapa.dispositivosGrid.ago': '{{value}} ago',
    'mapa.dispositivosGrid.minsAgo': '{{count}} min ago',
    'mapa.dispositivosGrid.hoursAgo': '{{count}} h ago',
    'mapa.dispositivosGrid.daysAgo': '{{count}} d ago',
  },
  es: {
    'mapa.dispositivosGrid.devices': 'Dispositivos',
    'mapa.dispositivosGrid.countOfTotal': '{{shown}} de {{total}}',
    'mapa.dispositivosGrid.empty': 'Ningún dispositivo rastreado.',
    // Cabeçalhos de coluna
    'mapa.dispositivosGrid.colTipo': 'Tipo',
    'mapa.dispositivosGrid.colStatusViagem': 'Estado del viaje',
    'mapa.dispositivosGrid.colOrigem': 'Origen',
    'mapa.dispositivosGrid.colDestino': 'Destino',
    'mapa.dispositivosGrid.colProgramadoPara': 'Programado para',
    'mapa.dispositivosGrid.colPlaca': 'Placa',
    'mapa.dispositivosGrid.colMotorista': 'Conductor',
    'mapa.dispositivosGrid.senhaNoTerminal': 'Contraseña en el terminal: {{nome}}',
    'mapa.dispositivosGrid.colJornada': 'Jornada',
    'mapa.dispositivosGrid.colLocalAtual': 'Ubicación actual',
    'mapa.dispositivosGrid.colCerca': 'Geocerca',
    'mapa.dispositivosGrid.colConexao': 'Conexión',
    'mapa.dispositivosGrid.colIgnicao': 'Encendido',
    'mapa.dispositivosGrid.colVelocidade': 'Velocidad',
    'mapa.dispositivosGrid.colSituacao': 'Situación',
    // Tooltips e rótulos acessíveis
    'mapa.dispositivosGrid.locateAria': 'Localizar {{label}} en el mapa',
    'mapa.dispositivosGrid.openInGoogleMaps': 'Abrir {{label}} en Google Maps',
    'mapa.dispositivosGrid.noPositionForMaps': 'Sin coordenada transmitida',
    'mapa.dispositivosGrid.transporteBadge': 'Transp. máquina',
    'mapa.dispositivosGrid.transporteBadgeTooltip': 'Plataforma en viaje de Transporte de Máquina: el estado mostrado es el del vehículo en ese viaje, bajo el contrato de destino.',
    'mapa.dispositivosGrid.programadoTooltip': 'Fecha y hora programada de la carga en la Frente de trabajo. En la plataforma, la fecha de inicio del viaje de máquina',
    'mapa.dispositivosGrid.inStatusSince': 'En este estado desde {{date}}',
    'mapa.dispositivosGrid.temperatureReading': 'Lectura de {{date}}',
    'mapa.dispositivosGrid.listBelowMap': 'Lista debajo del mapa',
    'mapa.dispositivosGrid.listRightSide': 'Lista en el lateral derecho',
    // Filtros
    'mapa.dispositivosGrid.filterByClient': 'Filtrar por cliente',
    'mapa.dispositivosGrid.client': 'Cliente',
    'mapa.dispositivosGrid.searchClient': 'Buscar cliente…',
    'mapa.dispositivosGrid.searchScheduledDate': 'Buscar fecha…',
    'mapa.dispositivosGrid.filterByTripStatus': 'Filtrar por estado del viaje',
    'mapa.dispositivosGrid.searchStatus': 'Buscar estado…',
    'mapa.dispositivosGrid.filterByCategory': 'Filtrar por categoría del vehículo',
    'mapa.dispositivosGrid.category': 'Categoría',
    'mapa.dispositivosGrid.category.espiga': 'Espiga',
    'mapa.dispositivosGrid.category.granel': 'Granel',
    'mapa.dispositivosGrid.category.prancha': 'Plataforma',
    'mapa.dispositivosGrid.category.maquina': 'Máquina',
    'mapa.dispositivosGrid.category.combustivel': 'Combustible',
    'mapa.dispositivosGrid.searchCategory': 'Buscar categoría…',
    'mapa.dispositivosGrid.filterByPair': 'Filtrar por pareja',
    'mapa.dispositivosGrid.pair': 'Pareja',
    'mapa.dispositivosGrid.searchPair': 'Buscar pareja…',
    'mapa.dispositivosGrid.filterByContract': 'Filtrar por contrato',
    'mapa.dispositivosGrid.contract': 'Contrato',
    'mapa.dispositivosGrid.garage': 'Garaje',
    'mapa.dispositivosGrid.searchContract': 'Buscar contrato…',
    'mapa.dispositivosGrid.searchFence': 'Buscar geocerca…',
    'mapa.dispositivosGrid.noContractFound': 'Ningún contrato encontrado',
    'mapa.dispositivosGrid.searchPlaceholder': 'Buscar placa, conductor, ciudad, origen, destino…',
    // Situação do rastreador
    'mapa.dispositivosGrid.signalTransmitting': 'Transmitiendo',
    'mapa.dispositivosGrid.signalLate': 'Retrasado',
    'mapa.dispositivosGrid.signalOffline': 'Sin señal',
    'mapa.dispositivosGrid.signalNever': 'Sin transmisión',
    'mapa.dispositivosGrid.signalLegendTitle': 'Señal del rastreador',
    'mapa.dispositivosGrid.signalTransmittingDesc': 'posición en los últimos 10 minutos',
    'mapa.dispositivosGrid.signalLateDesc': 'entre 10 minutos y 2 horas sin transmitir',
    'mapa.dispositivosGrid.signalOfflineDesc': 'más de 2 horas sin transmitir',
    'mapa.dispositivosGrid.signalNeverDesc': 'nunca envió posición',
    'mapa.dispositivosGrid.signalLegendNote': 'El color de la fila sigue el Estado del viaje, no la Situación.',
    // Tempo relativo
    'mapa.dispositivosGrid.now': 'ahora',
    'mapa.dispositivosGrid.ago': 'hace {{value}}',
    'mapa.dispositivosGrid.minsAgo': 'hace {{count}} min',
    'mapa.dispositivosGrid.hoursAgo': 'hace {{count}} h',
    'mapa.dispositivosGrid.daysAgo': 'hace {{count}} d',
  },
}
